<section class="py-3">
  <div class="container-fluid card">
    <div class="row align-items-center justify-content-between g-2 mb-2 pt-3">
      <div class="col-12 col-md-5">
        <app-main-heading [heading]="'Tyre Brand'" class="m-0"></app-main-heading>
      </div>
      <div class="col-12 col-md-7">
        <div class="row g-2 align-items-center justify-content-end">
          <div class="col-12 col-sm-6 col-md-5 col-lg-4">
            <div class="search-wrapper position-relative w-100">
              <input type="text" class="form-control search-input" placeholder="Search..."
                style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
                #searchTerm (input)="FilterList(searchTerm.value)">
              <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted"
                style="pointer-events: none; font-size: 13px;"></fa-icon>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <button class="btn app-btn-primary w-100" style="height: 38px; display: flex; align-items: center; justify-content: center;" (click)="tyreBrandFormPopup('add')">Add Tyre Brand</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card app-table-thick-border shadow-none mb-2">
      <div class="table-responsive app-scrollbar" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" (scrolled)="loadMore()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header">
              <th scope="col" sortable="">Name</th>
              <th scope="col" sortable="">Short Name</th>
              <th scope="col" sortable="">Action</th>
            </tr>
          </thead>
          <tbody>
            @if (makeList.length > 0) {
              @for (list of makeList; track list) {
                <tr class="app-table-body app-td-text">
                  <td class="td-text-three">{{list.name}}</td>
                  <td class="td-text-two text-muted">{{list.shortName}}</td>
                  <td>
                    <fa-icon class="btn app-btn-primary btn-sm" (click)="tyreBrandFormPopup('edit',list)" [icon]="faEdit"
                    ngbTooltip="Edit" [placement]="'left'"></fa-icon> &nbsp;
                  </td>
                </tr>
              }
            }

            <!-- Loader Row -->
            @if (loader) {
              <tr>
                <td colspan="3">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            }

            <!-- Empty State Row -->
            @if (!loader && makeList.length === 0) {
              <tr>
                <td colspan="3">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No Records Found!
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    </div>


    @if (showEditMakePopup) {
      <div class="popup-overlay">
        <div class="popup-container">
          <h3>{{popupType}} Tyre Brand</h3>
          <form [formGroup]="tyreBrandForm" (ngSubmit)="onEditSubmit()">
            <div class="row pt-2 g-2">
              <div class="col-12 col-md-6 mb-2">
                <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
                <input formControlName="name" id="name" type="text" class="form-control default-form-group-border" required
                  placeholder="Enter name*">
                  @if (
                    tyreBrandForm.get('name')?.invalid &&
                    tyreBrandForm.get('name')?.touched
                    ) {
                    <div>
                      <small class="text-danger">Name is required</small>
                    </div>
                  }
              </div>
              <div class="col-12 col-md-6 mb-2 customInput">
                <label for="shortName" class="form-label">Short Name</label>
                <div class="input-group">
                  <input formControlName="shortName" id="shortName" type="text"
                    class="form-control default-form-group-border" placeholder="Enter short name" appNoLeadingSpaces>
                    <div class="input-group-append">
                      <button type="button" (click)="addData()" class="btn app-btn-green button-custom-styles">
                        <fa-icon [icon]="faPlus"></fa-icon>
                      </button>
                    </div>
                  </div>
              </div>
            </div>
            <div class="data mb-2">
              @for (field of addedFields; track field) {
                <button class="btn btn-custom">{{field}}
                  <button type="button" class="btn-close btn-close-white" aria-label="close"
                  (click)="deleteFieldValues(field)"></button></button>
                }
            </div>
            @if (errorMessage) {
              <div>
                <p class="text-danger">{{ errorMessage }}</p>
              </div>
            }
            <!-- Action Buttons -->
            <div class="row pt-3">
              <div class="col-12 d-flex justify-content-end gap-2 button_section">
                <button type="button" class="btn pr-2" (click)="closePopup()">Cancel</button>
                <button type="submit" class="btn app-btn-primary sub_button" [disabled]="tyreBrandForm.invalid">
                  {{ this.popupType }}
                  @if (isLoading) {
                    <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
                  }
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    }
        </section>

        @if (isToster) {
          <app-toaster [title]="message" (closeToaster)="closeToster($event)"></app-toaster>
        }